import moment, { Moment } from "moment";

export type Schedule = {
  startAt: Moment;
  endAt: Moment;
  title: string;
}

export const schedules: Array<Schedule> = [
  {
    startAt: moment('2026-10-19T23:00:00+0900'),
    endAt: moment('2026-10-20T01:00:00+0900'),
    title: '令和8年10月19日(月)23:00～25:00',
  },
];

export const getCurrentSchedule = (now: Moment, schedules: Array<Schedule>): Schedule | undefined => {
  return schedules.find(x => x.endAt > now && now >= x.startAt)
}
